{
  "title": "Web",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a bit of spiderweb)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You conjure a mass of thick, sticky webbing at a point of your choice within range. The webs fill a 20-foot cube from that point for the duration. The webs are difficult terrain and lightly obscure their area.",
    "If the webs aren’t anchored between two solid masses (such as walls or trees) or layered across a floor, wall, or ceiling, the conjured web collapses on itself, and the spell ends at the start of your next turn. Webs layered over a flat surface have a depth of 5 feet.",
    "Each creature that starts its turn in the webs or that enters them during its turn must make a Dexterity saving throw. On a failed save, the creature is restrained as long as it remains in the webs or until it breaks free.",
    "A creature restrained by the webs can use its action to make a Strength check against your spell save DC. If it succeeds, it is no longer restrained.",
    "The webs are flammable. Any 5-foot cube of webs exposed to fire burns away in 1 round, dealing 2d4 fire damage to any creature that starts its turn in the fire."
  ],
  "spellLists": ["artificer", "sorcerer", "wizard"]
}
